import RenderBlocks from '../lists/BulletBlockList';
import { type EnergyAudit } from 'interfaces/EnergyAudit.interface';
import SourceLinksList from '@components/links/SourceLinksList';
import { type FC } from 'react';

interface EnergyAuditActionPlanTabProps {
  data: EnergyAudit;
}

const EnergyAuditActionPlanTab: FC<EnergyAuditActionPlanTabProps> = ({
  data,
}) => {
  const tabData = data.action_plan;
  const blocks = tabData?.blocks;

  return (
    <>
      {/* Action Plan Content */}
      <h3 className="text-base font-semibold text-gray-60 mb-2">Action Plan</h3>
      <RenderBlocks blocks={blocks} emptyMessage="No content available yet." />
      {/* Permits Section */}
      {data.permits &&
        Array.isArray(data.permits.blocks) &&
        data.permits.blocks.length > 0 && (
          <>
            <div className="h-px bg-primary/20 w-full mt-4" />
            <div className="mt-8">
              <h3 className="text-base font-semibold text-gray-60 mb-2">
                Permits
              </h3>
              <RenderBlocks blocks={data.permits.blocks} />
            </div>
            <div className="mt-3">
              <SourceLinksList urlList={data.permits_url} />
            </div>
          </>
        )}
    </>
  );
};

export default EnergyAuditActionPlanTab;
